import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import { APP_CONTEXT_URL } from 'src/constants/urls'

const app = createReducer(
    {
        userId: null,
        user: null,
        isAdmin: false,
        // teams: null,
        syncJobStatusChoices: null,
        actionStatusChoices: null,
        issueLogSeverities: null,
        issueLogPriorities: null,
        issueLogStatuses: null,
        activityLogPriorities: null,
        activityLogStatuses: null,
        websocketConfig: null,
        initialLoading: true,
    },
    {
        [actions.INIT_APP_SUCCESS]: (state, action) => {
            const { data } = action.payload
            return {
                ...state,
                userId: data.user_id,
                user: data.user,
                isAdmin: data.is_admin,
                // teams: window.localData.teams,
                // VT: For later I do not believe this should be in the state, or even props
                // These are constants and only belong in the component itself
                syncJobStatusChoices: data.job_type_statuses,
                actionStatusChoices: data.action_statuses,
                issueLogSeverities: data.issuelog_severities,
                issueLogPriorities: data.issuelog_priorities,
                issueLogStatuses: data.issuelog_statuses,
                activityLogPriorities: data.activitylog_priorities,
                activityLogStatuses: data.activitylog_statuses,
                websocketConfig: data.websocket_config,
                initialLoading: false,
            }
        },
        [actions.INIT_APP_ERROR]: (state) => {
            return {
                ...state,
                initialLoading: false,
            }
        },
    }
)

export const initApp = () => (dispatch) => {
    return dispatch({
        type: actions.API,
        method: 'GET',
        payload: {
            url: APP_CONTEXT_URL,
            start: () => ({ type: actions.INIT_APP }),
            success: (payload) => ({
                type: actions.INIT_APP_SUCCESS,
                payload,
            }),
            error: (error) => ({
                type: actions.INIT_APP_ERROR,
                error,
            }),
        },
    })
}

export default app
